import { Reveal } from "@/components/Reveal";
import WaitlistForm from "@/components/WaitlistForm";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function FinalCTA() {
  const { config } = useSiteConfig();
  const t = config.t.finalCta;
  return (
    <section id="final-cta" className="relative overflow-hidden bg-[#FAFAFC] py-28 sm:py-36" data-testid="final-cta-section">
      <div className="mesh-bg absolute inset-0" />
      <div className="relative mx-auto max-w-2xl px-6 text-center">
        <Reveal>
          <h2 className="text-4xl font-bold tracking-tighter text-neutral-900 sm:text-6xl">{t.heading}</h2>
          <p className="mx-auto mt-5 max-w-lg text-lg text-neutral-500">
            {t.paragraph}
          </p>
        </Reveal>
        <Reveal delay={0.1} className="mx-auto mt-10 max-w-md rounded-3xl border border-black/5 bg-white/80 p-6 shadow-xl backdrop-blur sm:p-8">
          <WaitlistForm source="final" showType={false} showZip={false} cta="Join the Waitlist" />
          <p className="mt-4 text-xs text-neutral-400">{t.note}</p>
        </Reveal>
      </div>
    </section>
  );
}
